import React from 'react'
import DatePicker from 'react-datepicker'

import { strings } from './emergencies-content'
import styles from '../../styles/modules/emergencies/emergencies-query.module.scss'
import 'react-datepicker/dist/react-datepicker.css'
import '../../styles/modules/react-datepicker.scss'

interface Props {
  onChangeFrom: (date: Date | null) => void
  onChangeTo: (date: Date | null) => void
  from: Date | null
  to: Date | null
}

const QueryDate: React.FC<Props> = props => (
  <div className={styles.container}>
    <span className={styles.title}>{strings.queryDateTitle}</span>
    <div className={styles.box}>
      <div className={styles.fromPickerWrapper}>
        <DatePicker
          onChange={date => props.onChangeFrom(date as Date | null)}
          selected={props.from}
          dateFormat={'yyyy/MM/dd'}
        />
      </div>
      <div className={styles.toPickerWrapper}>
        <DatePicker
          onChange={date => props.onChangeTo(date as Date | null)}
          selected={props.to}
          dateFormat={'yyyy/MM/dd'}
          maxDate={new Date()}
        />
      </div>
    </div>
  </div>
)

export default QueryDate
